import { Observable } from "rxjs";
import {IChatMessage, type IChatMessageResult} from "@listat/r2-core";
import r2Core from "@core/r2";
import {IChatActionsData} from "@core/base/chat-action-base";

export abstract class ChatBase {
    public constants = r2Core.constants.chat;
    public abstract getMessages(): Observable<IChatMessage[]>;
    public abstract getMessagesValue(): IChatMessage[];
    public abstract sendMessage(data: string, dataAction: IChatActionsData | null): Promise<IChatMessageResult>;
    public abstract sendMessageWithoutSaving(data: string, dataAction: IChatActionsData | null): Promise<IChatMessageResult>;
    public abstract clearMessages(): Promise<void>
    public abstract writeBotMessage(text: string): Promise<void>
    public abstract $isMessagesLoading(): Observable<boolean>
    public onDestroy(): void {}
}
